export interface IWalletBalance {
  offline: { [key: string]: IWalletCurrencyBalance };
  online: { [key: string]: IWalletCurrencyBalance };
  total: { [key: string]: IWalletCurrencyBalance };
}

export interface IWalletCurrencyBalance {
  amount: number;
  amount_formatted: string;
  amount_converted: number;
  amount_converted_formatted: string;
}

export enum WalletTransactionTypes {
  // Funds added after payment
  ADD = 1,

  // Funds spent on item
  SPEND = 2,

  // Refund to Wallet (unpaid credit note)
  // This is the refunded amount before it went to the gateway.
  REFUND_TO_WALLET = 3,

  // Refund to Gateway
  REFUND_TO_GATEWAY = 4,

  // Funds withdrawal
  WITHDRAW = 5,

  // Overpaid Credit Note
  OVERPAID_CREDIT_NOTE = 6,

  // Refund FROM wallet
  REFUND_FROM_WALLET = 7
}
